/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/style-prop-object */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {Component} from "react"
import {
    // getCategories, 
    getVideoCategories
} from "../../services/Api"
import "../SideBar.scss"
import {v4 as uuidv4} from 'uuid';
import {ListGroup} from "react-bootstrap";
import QuestionsFeed from "../feed/questions";

class VideoSideBar extends Component {
    constructor() {
        super()
        this.state = {
            categories: [],
        }
    }

    async componentDidMount() {
        const categories = await getVideoCategories()

        console.log(categories)

        this.setState({
            categories: categories,
        })
    }

    render() {
        return (
            <React.Fragment>
                <div>
                    <div className='sidebar w3-light-grey sideBarWidth '>
                        <div className='middleSection' id="sidebar-improve-your-feed">
                            <ListGroup>
                                <ListGroup.Item className='listFirstItem feedCateGoryName'>
                                    Improve Your feed{" "}
                                </ListGroup.Item>
                                <QuestionsFeed/>
                            </ListGroup>
                        </div>
                        {this.state.categories.map((item) => (
                            <div key={uuidv4()}
                                 onClick={() =>
                                     this.props.LoadQuestion(item._id)
                                 }
                                 className='SidebarIconText'
                            >
                                <div>
                                    <img
                                        className='sideBarIcon'
                                        src={require("../../icons/home-filled.svg")}
                                     alt="home filled svg"/>
                                </div>
                                <div>
                                    <div className='w3-bar-item  sideBarText '>
                                        {item.categoryName}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default VideoSideBar

